import { URI } from '@fiverr-private/futile';
import pathfinder from '@fiverr-private/pathfinder';

export const getLinkToSellerPage = (sellerName, options = {}) =>
    new URI(pathfinder('short_user', { id: sellerName }))
        .addParams({
            ...(options?.source && { source: options.source }),
            ...(options?.refCtxId && { ref_ctx_id: options.refCtxId }),
            ...(options?.contextReferrer && { context_referrer: options.contextReferrer }),
        })
        .toString();
